import React, { useState, useEffect } from 'react';
// import videoURL from '../../assest/YRC.mp4'
import { withRouter } from "react-router-dom"
import { Button, Typography } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined, SendOutlined, CheckCircleOutlined, BackwardOutlined, ForwardOutlined, CaretRightOutlined, PauseOutlined, UndoOutlined, FullscreenOutlined } from '@ant-design/icons';
import AssessmentQuestion from "./AssessmentQuestion";
import PanelSpinner from "./PanelSpinner";
import "./Chapter.scss";
import loader from '../../img/loader.gif';

import { getChapterDetail, insertChapterQuestions, insertVideoTime } from '../../actions/User-action';
import {
    Link
} from "react-router-dom";

// const videoURL = "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4";
import { action } from '../../store';
import { changeConfirmLocale } from 'antd/lib/modal/locale';

const Chapter = ({ chapterDetail, loading, match, userId, profileInfo }) => {
    const [state, setState] = useState({
        layout: 0,
        playCTA: true,
        isVideoPaused: false,
        isVideoCompleted: false,
        activeQuestion: 0,
        runningTime: "00:00",
        totalDuration: "00:00",
        questions: chapterDetail.questions,
        title: chapterDetail.chapter_name,
        description: chapterDetail.description,
        facilitator: chapterDetail.facilitator,
        videoURL: chapterDetail.video_url,
        lastSeen: chapterDetail.last_seen,
        retaking: true
    })
    const changeQuestion = (changeIndex) => {
        let actQtn = activeQuestion + changeIndex
        setState({ ...state, activeQuestion: actQtn });
    }
    const updateQuestion = (question, index) => {
        let qtns = questions
        qtns[index] = question
        setState({ ...state, questions: qtns });
        action(insertChapterQuestions({
            user_id: userId,
            question_id: question.id,
            score: question.answer,
            chapter_id: match.params.id
        }))
    }
    const { layout, playCTA, isVideoPaused, isVideoCompleted, questions, activeQuestion, title, facilitator, videoURL, runningTime, totalDuration, lastSeen, retaking,description } = state;
    const changeLayout = (stage, isWatchAgain = false) => {
        if (stage == 2) {
            let chapter_id = match.params.id
            let user_id = userId;
            action(getChapterDetail({ chapter_id, user_id }));
        }
        setState({ ...state, layout: stage });
        setTimeout(() => {
            if (stage == 1) {
                var video = document.getElementById("video");
                video.currentTime = isWatchAgain ? 0 : (lastSeen || 0)
            }
        })
    }

    const updateVideoTime = () => {
        var video = document.getElementById("video");
        var curmins = Math.floor(video.currentTime / 60);
        var cursecs = Math.floor(video.currentTime - curmins * 60);
        var durmins = Math.floor(video.duration / 60);
        var dursecs = Math.floor(video.duration - durmins * 60);
        if (cursecs < 10) { cursecs = "0" + cursecs; }
        if (dursecs < 10) { dursecs = "0" + dursecs; }
        if (curmins < 10) { curmins = "0" + curmins; }
        if (durmins < 10) { durmins = "0" + durmins; }
        setState({ ...state, runningTime: curmins + ":" + cursecs, totalDuration: durmins + ":" + dursecs })
        if (curmins && parseInt(curmins) > 0 && parseFloat(cursecs) == 0 && parseFloat(curmins) % 1 == 0) {
            console.log(curmins, parseFloat(cursecs))
            action(insertVideoTime({
                "user_id": userId,
                "chapter_id": match.params.id,
                "last_duration": video.currentTime,
                "is_done": false
            }))
        }
    }
    const playVideo = (e) => {
        let video = document.getElementById("video");
        setState({ ...state, playCTA: false, lastSeen: chapterDetail.isFailed || chapterDetail.isPassed ? 0 : lastSeen })

        video.onended = function () {
            let payload = {
                "user_id": userId,
                "chapter_id": match.params.id,
                "last_duration": video.duration,
                "is_done": false
            }
            setState({ ...state, playCTA: false, layout: 2, isVideoCompleted: true,retaking: false  })
            payload.is_done = true;
            action(insertVideoTime(payload))
        };
        video.currentTime = (!retaking && lastSeen )|| 0;
        video.play()
    }
    const pauseVideo = () => {
        let video = document.getElementById("video");
        video.pause()
        setState({ ...state, isVideoPaused: true })
    }
    const resumeVideo = () => {
        let video = document.getElementById("video");
        video.play()
        setState({ ...state, isVideoPaused: false })
    }
    const replayVideo = () => {
        let video = document.getElementById("video");
        video.pause()
        video.currentTime = 0
        video.play()
        setState({ ...state, isVideoPaused: false })
    }
    const rewindVideo = () => {
        let video = document.getElementById("video");
        video.pause()
        video.currentTime = video.currentTime - 6
        video.play()
        setState({ ...state, isVideoPaused: false })
    }
    const forwardVideo = () => {
        let video = document.getElementById("video");
        video.pause()
        video.currentTime = video.currentTime + 6
        video.play()
        setState({ ...state, isVideoPaused: false })
    }
    const fullScreen = () => {
        let video = document.getElementById("video");
        video.pause()
        video.play()
        video.requestFullscreen();
    }
    const submitAnswers = () => {
        let payload = {
            questions: [],
            callback: () => {
                changeLayout(2)
            }
        }
        questions.map((qtn) => {
            payload.questions.push({
                question_id: qtn.id,
                chapter_id: match.params.id,
                user_id: userId,
                score: qtn.answer
            })
        })
        action(insertChapterQuestions(payload))
    }
    const retake = () => {
        setState({ ...state, activeQuestion: 0, layout: 1, retaking: true  })
    }
    const { Title } = Typography;
    const watchAgain = () => {
        changeLayout(1, true)
    }
    useEffect(() => {
        let chapter_id = match.params.id
        let user_id = userId;
        action(getChapterDetail({ chapter_id, user_id }));
    }, [])
    useEffect(() => {
        if (chapterDetail) {
            let myState = {
                ...state, questions: chapterDetail.questions, title: chapterDetail.chapter_name,description: chapterDetail.description, facilitator: chapterDetail.facilitator,
                videoURL: chapterDetail.video_url, lastSeen: chapterDetail.last_seen
            }
            if (chapterDetail.isPassed) {
                myState.layout = 2
            } else {
                myState.layout = 0
            }
            setState(myState);
        }
    }, [chapterDetail]);
    return (
        <div className={chapterDetail && chapterDetail.isPassed ? "chapter-page": "chapter-page not-watched"}>
            {
                loading && (<PanelSpinner></PanelSpinner>)
            }
            <Title level={5} style={{ textAlign: 'center', backgroundColor: '#87d068', textTransform: "uppercase", margin: "-24px -24px 24px -24px", padding: "5px 0", color: "white" }}>
                {title}
                {
                    layout == 1 && !playCTA && (
                        <span style={{ float: "right", display: "inline-block", padding: "0 10px 0 10px" }}>
                            {runningTime}/{totalDuration}
                        </span>
                    )
                }
            </Title>
            {
                layout == 0 &&
                <div style={{ maxWidth: 800, margin: "0 auto", fontSize: 20, textAlign: 'center' }}>
                  
                                <div >
                                    Hello <strong>{profileInfo && profileInfo.name}</strong>,<br />
                                    {description} This session was facilitated by <strong>{facilitator}</strong> Please take the video session.
                                </div>
             
                    <div style={{ marginTop: 24 }}>

                                    <Button onClick={() => { changeLayout(1) }} type="primary" size="large" >
                                        {chapterDetail && lastSeen > 0 ? "Resume Lesson " : "Start Lesson "}
                                        <ArrowRightOutlined />
                                    </Button>
                                
                        
                    </div>
                </div>
            }
            {
                layout == 1 &&
                <div style={{ position: "relative" }}>
                    {
                        playCTA && (<Button className="video-btn" onClick={playVideo} type="primary" size="large" ><CaretRightOutlined /> </Button>)
                    }
                    <video className="lesson-video" id="video" style={{ width: "100%", objectFit: "fill" }} poster="" onTimeUpdate={updateVideoTime} controls>
                        <source type="video/mp4" src={videoURL}></source>
                    </video>
                    {
                        !playCTA && (
                            <div className="video-control">
                                <Button type="secondary" onClick={rewindVideo} ><BackwardOutlined /></Button>
                                <Button type="secondary" onClick={pauseVideo}><PauseOutlined /></Button>
                                <Button onClick={resumeVideo} ><CaretRightOutlined /></Button>
                                <Button type="secondary" onClick={replayVideo}><UndoOutlined /></Button>
                                <Button type="secondary" onClick={fullScreen} ><FullscreenOutlined /></Button>
                                { (isVideoCompleted || (chapterDetail && chapterDetail.isPassed)) && <Button type="secondary" onClick={forwardVideo} ><ForwardOutlined /></Button>}
                                { (isVideoCompleted || (chapterDetail && chapterDetail.isPassed)) && (<Button type="secondary"  href="https://www.tyclinternational.org/art-camp/#/user" style={{ backgroundColor: '#87d068', color: "white" }}> Continue Course <ArrowRightOutlined /> </Button>)}
                            </div>
                        )
                    }
                </div>
            }
           
            {
                layout == 2 &&
                <div style={{ maxWidth: 800, margin: "0 auto", fontSize: 20, textAlign: 'center' }}>
                            <div>
                                Congratulations <strong>{profileInfo && profileInfo.name}</strong>!<br />
                                You have successfuly completed this session of Virtual Creative ARt program. Let's get into the next Segment.
                            </div>
        
                            <div style={{ marginTop: 24 }}>
                                <Button href="https://www.tyclinternational.org/art-camp/#/user" type="primary" size="large" >Continue <ArrowRightOutlined /> </Button>
                                <Button  style={{marginLeft: "3px"}} onClick={() => { retake() }} type="danger" size="large" >Watch Again <ArrowRightOutlined /> </Button>
                            </div>
                            
                    

                </div>
            }
        </div >
    )
}
export default withRouter(Chapter) 